import { useAllowedEmpresas } from './useAllowedEmpresas'

/**
 * ¿Puede este usuario EDITAR fichas técnicas, o sólo mirarlas?
 *
 * Editar exige 'tdis' (App Role Empresa.TDIS o Empresa.All). El módulo se abrió
 * a Empresa.AVP el 2026-09-05, pero **sólo para consultar**: las fichas se
 * capturan desde Tailored y AVP entra a mirarlas.
 *
 * Va separado de `useHasBomAccess` porque responden a preguntas distintas —
 * «¿ve el módulo?» y «¿puede tocarlo?»— y desde hoy tienen respuestas distintas.
 *
 * Esto sólo decide qué se pinta. El cierre de verdad está en el backend
 * (`exigir_edicion_bom`), que devuelve 403 a las seis rutas que modifican algo:
 * esconder un botón evita el clic, no la llamada.
 */
export function useCanEditBom(): boolean {
  return useAllowedEmpresas().includes('tdis')
}
